import difference from 'lodash/difference'
import get from 'lodash/get'
import omitBy from 'lodash/omitBy'

import { SYMBOL_OMIT } from '../constants/compareData'

import { getItemsIds } from './common'
import { formatDateToApi } from './date'

function getArrayValuesByKey(array, key) {
  return array.map(value => get(value, key))
}

export function compareArrays(initial, updated) {
  return difference(initial, updated).length > 0 ||
    difference(updated, initial).length > 0
    ? updated
    : SYMBOL_OMIT
}

export function compareArraysBy(initial, updated, key) {
  return compareArrays(
    getArrayValuesByKey(initial, key),
    getArrayValuesByKey(updated, key)
  )
}

export function comparePrimitives(initial, updated) {
  return initial !== updated ? updated : SYMBOL_OMIT
}

export function compareDates(initial, updated, timezone) {
  const updatedFormatted = formatDateToApi(updated, timezone)

  return formatDateToApi(initial, timezone) !== updatedFormatted
    ? updatedFormatted
    : SYMBOL_OMIT
}

export function compareFilesById(initial, updated) {
  return get(initial, 'id', null) !== updated ? updated : SYMBOL_OMIT
}

export function compareFileArrays(initial, updated) {
  return compareArrays(getItemsIds(initial), getItemsIds(updated))
}

export function getUpdatedData(comparedData) {
  return omitBy(comparedData, val => val === SYMBOL_OMIT)
}

export function compareEmailThreadsArrays(initial, updated) {
  return compareArrays(
    getItemsIds(initial, 'uuid'),
    getItemsIds(updated, 'uuid')
  )
}
